import React, { useState, useMemo } from "react";
import axios from "axios";

export default function NewAdmin() {
  const [name, setName] = useState("");
  const [eMail, setMail] = useState("");
  const [password, setPassword] = useState("");

  const [submitting, setSubmitting] = useState(false);
  const [complete, setComplete] = useState(false);
  const [errorField, setErrorField] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  function validate() {
    if (!name.trim()) return "Name-Surname is required.";
    if (!eMail.trim()) return "Email is required.";
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(eMail.trim());
    if (!emailOk) return "Please enter a valid email address.";
    if (!password) return "Password is required.";
    if (password.length < 6) return "Password must be at least 6 characters.";
    return "";
  }

  const isFormInvalid = useMemo(() => !!validate() || submitting, [name, eMail, password, submitting]);

  async function addAdmin(e) {
    e.preventDefault();
    setComplete(false);
    setSubmitting(true);
    setErrorField("");
    setErrorMsg("");

    const v = validate();
    if (v) {
      setSubmitting(false);
      setErrorField(v);
      return;
    }

    try {
      const res = await axios.post("https://act-api.vercel.app/addanadmin", {
        name,
        eMail,      
        password,
      });

      if (res?.status === 201 || res?.status === 200) {
        setComplete(true);
        setName("");
        setMail("");
        setPassword("");
      } else {
        setErrorMsg("Unexpected response. Please try again.");
      }
    } catch (error) {
      const status = error?.response?.status;
      const payload = error?.response?.data;
      const msg = payload?.error || payload?.hata || "Operation failed. Please try again.";

      if (status === 409) {
        // Aynı e-mail
        setErrorField(msg || "This e-mail is already registered.");
      } else if (status === 400) {
        // Eksik alan/validasyon
        setErrorField(msg);
      } else {
        // Sunucu vs.
        setErrorMsg(msg);
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 text-slate-800">
      {/* Üst başlık */}
      <div className="sticky top-0 z-10 bg-white/70 backdrop-blur supports-[backdrop-filter]:bg-white/50 border-b border-slate-200">
        <div className="mx-auto max-w-md px-4 sm:px-6 py-3 flex items-center justify-between">
          <h1 className="text-lg font-semibold">New Admin</h1>
          <span className="text-sm text-slate-500">Create an admin account</span>
        </div>
      </div>

      {/* İçerik */}
      <div className="mx-auto max-w-md px-4 sm:px-6 py-8">
        {errorMsg && (
          <div className="mb-6 rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
            {errorMsg}
          </div>
        )}
        {complete && (
          <div className="mb-6 rounded-xl border border-green-200 bg-green-50 p-4 text-sm text-green-700">
            You added an admin.
          </div>
        )}
        {errorField && (
          <div className="mb-6 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800">
            {errorField}
          </div>
        )}

        <form onSubmit={addAdmin} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <div className="grid grid-cols-1 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Name-Surname <span className="text-red-500">*</span>
              </label>
              <input
                placeholder="Pick Your Name Surname"
                className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-400"
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoComplete="name"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Email <span className="text-red-500">*</span>
              </label>
              <input
                placeholder="Enter Your Email"
                className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-400"
                value={eMail}
                onChange={(e) => setMail(e.target.value)}
                type="email"
                autoComplete="email"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Password <span className="text-red-500">*</span>
              </label>
              <input
                placeholder="Enter Your Password"
                className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-400"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                autoComplete="new-password"
              />
              <p className="mt-1 text-xs text-slate-500">At least 6 characters.</p>
            </div>
          </div>

          <div className="mt-6">
            <button
              type="submit"
              disabled={isFormInvalid}
              className="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-200 disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {submitting ? (
                <>
                  <svg
                    className="h-4 w-4 animate-spin"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                  Saving…
                </>
              ) : (
                "Save"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
